// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /profile/search-by-username.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeProfileSearchByUsernameBody,
  typeProfileSearchByUsernameOutput200,
} from "../../sdk/profile/postProfileSearchByUsername";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildProfileSearchByUsernameQueryKey(
  payload: typeProfileSearchByUsernameBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`username:${JSON.stringify(payload.username)}`);
  return [
    "post:profile:profileSearchByUsername",
    "svc:profile-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeProfileSearchByUsernameOutput200,
    unknown,
    typeProfileSearchByUsernameOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useProfileSearchByUsername(
  payload: typeProfileSearchByUsernameBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildProfileSearchByUsernameQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postProfileSearchByUsername(payload),
    ...resolvedOptions,
  });
}
